import { ThemeProvider } from 'next-themes';
import type { ReactNode } from 'react';
import { Toaster } from '~/components/ui/sonner';
import { TooltipProvider } from '~/components/ui/tooltip';
import { ShortcutsProvider } from '~/features/shortcuts/ShortcutsProvider';
import { useGlobalShortcuts } from '~/features/shortcuts/useGlobalShortcuts';

function GlobalShortcuts() {
  useGlobalShortcuts();
  return null;
}

export function Providers({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange
      storageKey="spriteer-theme"
    >
      <ShortcutsProvider>
        <TooltipProvider delayDuration={300}>
          <GlobalShortcuts />
          {children}
          <Toaster />
        </TooltipProvider>
      </ShortcutsProvider>
    </ThemeProvider>
  );
}
